import { registerRadarSeries } from "../../series/radar/radar";

import { SeriesTypeEnum } from "../../series/interface/type";

import { Factory } from "../../core/factory";

import { RadarChartSpecTransformer } from "./radar-transformer";

import { BaseChart } from "../base";

import { StackChartMixin } from "../stack";

import { mixin } from "@visactor/vutils";

import { registerDimensionHover } from "../../interaction/triggers/dimension-hover";

import { registerDimensionEvents } from "../../event/events";

import { getPolarDimensionInfo } from "../../event/events/dimension/util/polar";

import { registerDimensionTooltipProcessor } from "../../component/tooltip/processor/dimension-tooltip";

import { registerMarkTooltipProcessor } from "../../component/tooltip/processor/mark-tooltip";

import { registerGroupTooltipProcessor } from "../../component/tooltip/processor/group-tooltip";

export class RadarChart extends BaseChart {
    constructor() {
        super(...arguments), this.transformerConstructor = RadarChartSpecTransformer, this.type = "radar", 
        this.seriesType = SeriesTypeEnum.radar;
    }
    _setModelOption() {
        this._modelOption.getDimensionInfo = getPolarDimensionInfo;
    }
}

RadarChart.type = "radar", RadarChart.seriesType = SeriesTypeEnum.radar, RadarChart.transformerConstructor = RadarChartSpecTransformer, 
mixin(RadarChart, StackChartMixin);

export const registerRadarChart = () => {
    registerDimensionTooltipProcessor(), registerMarkTooltipProcessor(), registerGroupTooltipProcessor(), 
    registerDimensionEvents(), registerDimensionHover(), registerRadarSeries(), Factory.registerChart(RadarChart.type, RadarChart);
};
//# sourceMappingURL=radar.js.map
